import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class ContactFormService {
  _showContactForm$ = new BehaviorSubject(false);
  _contactFormCategory$ = new BehaviorSubject('');
  _contactFormDescription$ = new BehaviorSubject('');
  _contactFormRequestType = 'CustomerPortal';
  _supportAppBaseUrl = '';
  get showContactForm$() {
    return this._showContactForm$.asObservable();
  }
  get contactFormCategory$() {
    return this._contactFormCategory$.asObservable();
  }
  get contactFormDescription$() {
    return this._contactFormDescription$.asObservable();
  }
  get getContactFormRequestType() {
    return this._contactFormRequestType;
  }
  get getSupportAppBaseUrl() {
    return this._supportAppBaseUrl;
  }
  set setContactFormCategory(value) {
    this._contactFormCategory$.next(value);
  }
  set setContactFormDescription(value) {
    this._contactFormDescription$.next(value);
  }
  set setContactFormRequestType(value) {
    this._contactFormRequestType = value;
  }
  set setSupportAppBaseUrl(value) {
    this._supportAppBaseUrl = value;
  }
  showContactForm() {
    this._showContactForm$.next(true);
  }
  closeContactForm() {
    this._showContactForm$.next(false);
  }
  static ɵfac = function ContactFormService_Factory(t) {
    return new (t || ContactFormService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactFormService,
    factory: ContactFormService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactFormService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
